const calcForecast = (data, trajLevel) => {
    return  parseFloat(trajLevel * data.forecastYears) +
    parseFloat(data.currentValue);
}

export default calcForecast